import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-form-modal',
  templateUrl: './form-modal.component.html',
  styleUrls: ['./form-modal.component.scss'],
})
export class FormModalComponent {
  @Input() title!: string;
  @Input() visible!: boolean;
  @Input() formId!: string;
  @Input() submitLabel: string = 'Save';
  @Input() cancelLabel: string = 'Cancel';
  @Input() disabled?: boolean = false;
  @Input() noCancel?: boolean = false;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancelForm: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  handleCancel() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.cancelForm.emit();
  }
}
